import { useQueryClient } from '@tanstack/react-query';

import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';

type EscalationChannelMessage = {
  action: 'refetch';
};

export function useEscalationWebSocket() {
  const queryClient = useQueryClient();

  useWebsocketSubscription<EscalationChannelMessage>({
    channel: 'EscalationsChannel',
    onReceived: (data) => {
      if (data.action === 'refetch') {
        queryClient.invalidateQueries({
          queryKey: ['escalations'],
        });
      }
    },
  });
}
